import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaEye,
  FaEyeSlash,
  FaGithub,
  FaGoogle,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import AuthService from "../services/authService";
import { auth, provider, signInWithPopup } from "../firebase";  
// import Otpmodal from "./PhoneAuth";
// import { Phone } from "@mui/icons-material";
import PhoneAuth from "./PhoneAuth";




const Register = (props) => {

  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [step, setStep] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    verificationCode: "",
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const toggleForm = () => {
    setIsRegister(!isRegister);
    setStep(1);
    setFormData({ name: "", email: "", password: "", verificationCode: "" });
    setError(null);
  };

  const handleSendVerificationCode = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/send-verification`,
        { email: formData.email }
      );
      setStep(2);
      setError(null);
    } catch (err) {
      setError("Failed to send verification code. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // register
    if (isRegister) {
      if (step === 1) {
        handleSendVerificationCode();
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/auth/register-with-code`,
          {
            username: formData.name,
            email: formData.email,
            password: formData.password,
            verificationCode: formData.verificationCode,
          }
        );

        await AuthService.handleAuthentication(response.data, navigate);
      } catch (err) {
        setError(
          "Registration failed. Please check your verification code or try again."
        );
      }
    } else {
      // login
      try {
        const response = await AuthService.login({
          identifier: formData.email,
          password: formData.password,
        });

        await AuthService.handleAuthentication(response, navigate);
      } catch (err) {
        setError(
          err.message ||
            "Login failed. Please check your credentials or try again."
        );
      }
    }
  };

 
  async function loginWithGoogle() {
    try {
      // Sign in with Google popup
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // console.log("Google User:", user);
      // Get Firebase ID token
      const firebaseToken = await user.getIdToken();
      // console.log("Firebase Token:", firebaseToken);
      // Send token to Strapi API for verification and login
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/fireauth/verify`, {
        googleApiToken: firebaseToken,
      });
  
      console.log("Access Token from Strapi:", response.data);
      
      // Store access token for future API requests
     localStorage.setItem("accessToken", response.data.accessToken);
    localStorage.setItem("user", JSON.stringify(response.data.user));
    navigate(-1);

    } catch (error) {
      console.error("Error during login or API call:", error);
    }
  }
  
  return (
    <section className={`text-gray-600 body-font bg-${props.mode}`}>
      <div className="container px-5 py-10 mx-auto flex flex-wrap items-center">
        {/* Left section */}
        <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0">
          <h1
            className={`title-font font-medium text-3xl text-${
              props.mode === "black" ? "white" : "black"
            }`}
          >
            {!isRegister
              ? "Welcome back! Log in to continue."
              : step === 1
              ? "Create your account and start hacking!"
              : "Verify your email"}
          </h1>
          <p className="leading-relaxed mt-4">
            {!isRegister
              ? "Enter your credentials to access your account."
              : step === 1
              ? "Sign up to access exclusive features and updates."
              : "Please enter the verification code sent to your email."}
          </p>
        </div>

        {/* Form */}
        <div className="lg:w-2/6 md:w-1/2 bg-gray-100 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0">
          <p
            className="text-lg font-medium title-font mb-5 text-black"
            style={{ color: "black" }}
          >
            {isRegister ? "Register" : "Login"}
          </p>

          {!isRegister && (
            <>
              {/* Social Login Buttons */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <button className="flex items-center justify-center bg-gray-800 text-white rounded px-4 py-2 hover:bg-gray-900">
                  <FaGithub className="mr-2" /> GitHub
                </button>
                <button onClick={loginWithGoogle} className="flex items-center justify-center bg-red-600 text-white rounded px-4 py-2 hover:bg-red-700">
                  <FaGoogle className="mr-2" /> Google
                </button>
                <button onClick={() => setIsModalOpen(true)} className="flex items-center justify-center bg-red-600 text-white rounded px-4 py-2 hover:bg-red-700">Verify Phone</button>
                <button className="flex items-center justify-center bg-blue-400 text-white rounded px-4 py-2 hover:bg-blue-500">
                  <FaTwitter className="mr-2" /> Twitter
                </button>
                <button className="flex items-center justify-center bg-blue-600 text-white rounded px-4 py-2 hover:bg-blue-700">
                  <FaFacebook className="mr-2" /> Facebook
                </button>
              </div>

              <div className="relative flex py-2 items-center">
                <div className="flex-grow border-t border-gray-300"></div>
                <span className="flex-shrink mx-4 text-gray-600">or</span>
                <div className="flex-grow border-t border-gray-300"></div>
              </div>
            </>
          )}

          {/* Form Fields */}
          {isRegister && step === 1 && (
            <div className="relative mb-4">
              <label htmlFor="name" className="leading-7 text-sm text-gray-600">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8"
              />
            </div>
          )}

          {(!isRegister || step === 1) && (
            <>
              <div className="relative mb-4">
                <label
                  htmlFor="email"
                  className="leading-7 text-sm text-gray-600"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8"
                />
              </div>

              <div className="relative mb-4">
                <label
                  htmlFor="password"
                  className="leading-7 text-sm text-gray-600"
                >
                  Password
                </label>
                <div className="flex items-center">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8"
                  />

                  <button
                    type="button"
                    onClick={() => setPasswordVisible(!passwordVisible)}
                    className="absolute right-4"
                  >
                    {passwordVisible ? (
                      <FaEyeSlash className="text-gray-600" />
                    ) : (
                      <FaEye className="text-gray-600" />
                    )}
                  </button>
                </div>
              </div>
            </>
          )}

          {/* Verification Code input */}
          {isRegister && step === 2 && (
            <div className="relative mb-4">
              <label
                htmlFor="verificationCode"
                className="leading-7 text-sm text-gray-600"
              >
                Verification Code
              </label>
              <input
                type="text"
                id="verificationCode"
                name="verificationCode"
                value={formData.verificationCode}
                onChange={handleInputChange}
                className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8"
                placeholder="Enter 6-digit code"
              />
            </div>
          )}

          {/* error message */}
          {error && (
            <p className="text-xs text-red-500 mb-4" style={{ color: "red" }}>
              {error}
            </p>
          )}

          {/* login/register button */}
          <button
            onClick={handleSubmit}
            className="text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg"
          >
            {!isRegister
              ? "Login"
              : step === 1
              ? "Register"
              : "Verify & Register"}
          </button>

          {/* resend verification code */}
          {isRegister && step === 2 && (
            <button
              onClick={handleSendVerificationCode}
              className="mt-4 text-indigo-500 hover:underline focus:outline-none"
              style={{ color: "black" }}
            >
              Resend verification code
            </button>
          )}

          {/* resend text */}
          {/* <p className="text-xs mt-3 text-black" style={{ color: "black" }}>
            {isRegister
              ? "By registering, you agree to our terms and privacy policy."
              : "Forgot your password? Reset it here."}
          </p> */}

          {/* toggle text */}
          <button
            onClick={toggleForm}
            className="mt-5 text-indigo-500 hover:underline focus:outline-none"
          >
            {isRegister
              ? "Already have an account? Login"
              : "Don't have an account? Register"}
          </button>
        </div>
      </div>
     <PhoneAuth isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </section>
  );
};

export default Register;
